import FullscreenOn from './FullscreenOn'

export default FullscreenOn
// eslint-disable-next-line import/export
export * from './FullscreenOn'
